import { module } from "../modular/modular";
import { html } from "../utils/environment";

export default class extends module {
	constructor(m) {
		super(m);
	}

	init() {

		this.update();
	}

	update() {
		html.classList.remove(`has-theme-greenDark`);
		html.classList.remove(`has-theme-greenLight`)
		html.classList.remove(`has-theme-yellow`);
		html.classList.remove(`has-theme-light`);
		html.classList.remove(`has-theme-dark`);

		let container = document.getElementById('swup');
		let theme = container.getAttribute('data-theme');
		
		if(theme != null) {
			html.classList.add(`has-theme-${theme}`);
		}
	}

	trigger(e) {
		// data-module-theme="uID" data-scroll data-scroll-repeat data-scroll-call="trigger,Theme, uID"
		// data-trigger-top="light" data-trigger-bottom="dark"
		
		let themes = [
			e.$el.getAttribute("data-trigger-out"),
			e.$el.getAttribute("data-trigger-in"),
		];
		
		if (e.mode === "enter") {
			html.classList.remove(themes[0]);
			html.classList.add(themes[1]);
		}
		if (e.mode === "leave") {
			html.classList.remove(themes[1]);
			html.classList.add(themes[0]);
		}
	}

	destroy() {

	}
}
